import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import QrScanner from 'qr-scanner';
import { Container, Row, Col, Button, Alert } from 'react-bootstrap';
import { Camera, ArrowLeft, Play, Pause } from 'iconoir-react';

const QRScanner = () => {
  const [error, setError] = useState('');
  const [scanning, setScanning] = useState(false);
  const [hasCamera, setHasCamera] = useState(false);
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const qrScannerRef = useRef(null);

  useEffect(() => {
    // Verificar se há câmera disponível
    QrScanner.hasCamera().then(hasCamera => {
      setHasCamera(hasCamera);
      if (!hasCamera) {
        setError('Nenhuma câmera encontrada no dispositivo.');
      }
    });

    return () => {
      if (qrScannerRef.current) {
        qrScannerRef.current.destroy();
      }
    };
  }, []);

  const startScanning = async () => {
    if (!hasCamera || !videoRef.current) return;

    try {
      setError('');
      
      if (qrScannerRef.current) {
        qrScannerRef.current.destroy();
      }

      qrScannerRef.current = new QrScanner(
        videoRef.current,
        (result) => handleScan(result.data),
        {
          onDecodeError: (err) => {
            // Erro silencioso durante a leitura
          },
          highlightScanRegion: true,
          highlightCodeOutline: true,
          preferredCamera: 'environment'
        }
      );

      await qrScannerRef.current.start();
      setScanning(true);
    } catch (err) {
      setError('Erro ao acessar a câmera. Verifique as permissões.');
    }
  };

  const stopScanning = () => {
    if (qrScannerRef.current) {
      qrScannerRef.current.stop();
      setScanning(false);
    }
  };

  const handleScan = (data) => {
    if (data) {
      stopScanning();
      
      try {
        // Tentar como URL completa primeiro
        const url = new URL(data);
        const pathname = url.pathname;
        const pathParts = pathname.split('/').filter(part => part);
        
        
        // Verificar se é uma URL de dinein (QR code de mesa)
        if (pathParts.length >= 2 && pathParts[0] === 'dinein') {
          const token = pathParts[1];
          navigate(`/dinein/${token}`);
          return;
        }
        
        // Verificar se é uma URL de mesa direta (compatibilidade)
        if (pathParts.length >= 2 && pathParts[0] === 'mesa') {
          const token = pathParts[1];
          navigate(`/dinein/${token}`);
          return;
        }
        
        // Outras rotas
        if (pathname.includes('/delivery')) {
          navigate('/delivery');
        } else if (pathname.includes('/balcao')) {
          navigate('/balcao');
        } else {
          navigate('/');
        }
      } catch (err) {
        
        // Verificar se contém token de dinein ou mesa diretamente
        if (data.includes('/dinein/')) {
          const token = data.split('/dinein/')[1].split('/')[0].split('?')[0];
          if (token) {
            navigate(`/dinein/${token}`);
            return;
          }
        }
        
        if (data.includes('/mesa/')) {
          const token = data.split('/mesa/')[1].split('/')[0].split('?')[0];
          if (token) {
            navigate(`/dinein/${token}`);
            return;
          }
        }
        
        // Verificar se é apenas o token (sem URL)
        if (data.length > 5 && data.length < 50 && !data.includes(' ')) {
          navigate(`/dinein/${data}`);
          return;
        }
        
        setError('QR Code inválido. Tente novamente.');
        setTimeout(() => {
          setError('');
          if (hasCamera) startScanning();
        }, 2000);
      }
    }
  };

  return (
    <Container className="py-4">
      <Row className="justify-content-center">
        <Col xs={12} md={6}>
          <div className="text-center mb-4">
            <Button 
              variant="outline-secondary" 
              onClick={() => navigate(-1)}
              className="mb-3"
            >
              <ArrowLeft className="me-2" />
              Voltar
            </Button>
            
            <h2 className="mb-3">
              <Camera className="me-2" />
              Ler QR Code
            </h2>
            
            <p className="text-muted">
              Aponte a câmera para o QR Code da mesa
            </p>
          </div>

          {error && (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          )}

          <div className="border rounded p-3 bg-light text-center">
            <video 
              ref={videoRef}
              style={{
                width: '100%',
                maxWidth: '400px',
                height: '300px',
                objectFit: 'cover',
                borderRadius: '8px',
                backgroundColor: '#000'
              }}
            />
            
            <div className="mt-3">
              {hasCamera && (
                <Button
                  variant={scanning ? "danger" : "success"}
                  onClick={scanning ? stopScanning : startScanning}
                  className="me-2"
                >
                  {scanning ? (
                    <><Pause className="me-2" />Parar Scanner</>
                  ) : (
                    <><Play className="me-2" />Iniciar Scanner</>
                  )}
                </Button>
              )}
            </div>
          </div>

          <div className="text-center mt-3">
            <small className="text-muted">
              {scanning ? 'Posicione o QR Code da mesa dentro da área de leitura' : 'Clique em "Iniciar Scanner" para começar'}
            </small>
          </div>

          <div className="mt-4 text-center">
            <Button 
              variant="outline-primary" 
              onClick={() => navigate('/')}
              className="me-2"
            >
              Ver Cardápio
            </Button>
            <Button 
              variant="outline-success" 
              onClick={() => navigate('/loja')}
            >
              Informações da Loja
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default QRScanner;